<script setup lang="ts">
import { toRef } from "vue";

import { provideTableDense } from "./density.ts";

defineOptions({ inheritAttrs: false });

const props = withDefaults(defineProps<{ dense?: boolean }>(), { dense: false });

provideTableDense(toRef(props, "dense"));
</script>

<template>
  <div class="w-full overflow-visible">
    <table class="w-full caption-bottom text-sm" v-bind="$attrs">
      <slot />
    </table>
  </div>
</template>
